import { RichText } from '@graphcms/rich-text-react-renderer'
import { createIdForHeading } from '#app/utils/util'
import { ListItem, OrderedList, UnOrderedList } from './list'
import { H1, H2, H3, H4, H5, H6, Paragraph } from './typography'

export const RichContent = ({ content, references }: any) => {
	return (
		<RichText
			content={content}
			renderers={{
				h1: ({ children }) => <H1>{children}</H1>,
				h2: ({ children }) => {
					const contentText = children?.props.content[0]
						.text as unknown as string
					const createUniqueRef = createIdForHeading(contentText)
					return (
						<H2 id={createUniqueRef}>
							<span>{children}</span>
						</H2>
					)
				},
				h3: ({ children }) => <H3>{children}</H3>,
				h4: ({ children }) => <H4>{children}</H4>,
				h5: ({ children }) => <H5>{children}</H5>,
				h6: ({ children }) => <H6>{children}</H6>,
				p: ({ children }) => (
					<Paragraph className="mb-3 text-justify">{children}</Paragraph>
				),
				a: ({ children, href, openInNewTab }) => {
					const classes =
						'font-bold text-[#C75300] hover:text-[#23583A] hover:underline hover:cursor-pointer'
					if (openInNewTab) {
						return (
							<a href={href} className={classes} target="__blank">
								{children}
							</a>
						)
					}
					return (
						<a href={href} className={classes}>
							{children}
						</a>
					)
				},
				ul: ({ children }) => <UnOrderedList>{children}</UnOrderedList>,
				ol: ({ children }) => <OrderedList>{children}</OrderedList>,
				li: ({ children }) => <ListItem>{children}</ListItem>,
				blockquote: ({ children }) => (
					<div className="border-l-2 pl-4">
						<p className="my-6 text-lg">{children}</p>
					</div>
				),
				img: ({ src, altText, width, height }) => (
					<img
						width={width}
						height={height}
						alt={altText}
						src={src}
						className="mb-8"
					/>
				),
				iframe: ({ url, height, width }) => (
					<iframe height={height} width={width} src={url} className="mx-auto" />
				),
				embed: {
					Iframe: ({ url, height, width, title }) => (
						<iframe
							height={height}
							width={width}
							src={url}
							className="mx-auto max-h-[630px] max-w-xs lg:max-h-max lg:max-w-full"
							title={title}
						/>
					),
				},
			}}
			references={references}
		/>
	)
}
